<template>
  <!--  https://jsfiddle.net/mani04/bgzhw68m/-->
  <div class="f-row">
    <input
      type="text"
      class=""
      v-bind:class="[
        blue ? 'blue-input' : tableFormat ? 'optim-input' : 'custom-input',
      ]"
      :disabled="deactivate"
      v-model.lazy="displayValue"
      @blur="isInputActive = false"
      @focus="isInputActive = true"
    />
  </div>
</template>

<script>
export default {
  name: "InputPercent",
  data() {
    return {
      isInputActive: false,
    };
  },
  props: {
    blue: { required: false, type: Boolean, default: false },
    deactivate: { required: false, type: Boolean, default: false },
    readValue: { required: false, type: Boolean, default: false },
    stopEmitting: { required: false, type: Boolean, default: false },
    tableFormat: { required: false, type: Boolean, default: false },
    value: { required: true },
  },
  watch: {
    value(val) {
      if (this.readValue === true) {
        this.displayValue = val.toString();
      }
    },
  },
  computed: {
    displayValue: {
      get: function() {
        if (this.isInputActive) {
          // Cursor is inside the input field. Format display value for user
          return this.value.toString();
        } else {
          // User is not modifying now. Format display value for user interface
          let val = this.value;
          if (typeof val === "string") {
            val = parseFloat(val);
          }
          return (
            val.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") + "%"
          );
        }
      },
      set: function(modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        let newValue = parseFloat(modifiedValue.replace(/[^\d.-]/g, ""));
        // Ensure that it is not NaN
        if (Number.isNaN(newValue)) {
          newValue = 0;
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        if (this.stopEmitting === false) {
          this.$emit("input", newValue);
        }
      },
    },
  },
};
</script>

<style scoped></style>
